// @ngInject
Filters.PluralizeFilter = () => {
    return (number, text, pluralText, includeNumber=true) => {
        number = parseFloat(number);
        pluralText = !pluralText ? 's' : pluralText;
        const suffix = (!isNaN(number) && Math.abs(number) !== 1) ? pluralText : '';
        return `${includeNumber ? number : ''} ${text}${suffix}`.trim();
    };
};
